import {Pressable, StyleSheet, View} from "react-native";
import {Color} from "@/lib/styles";
import {useMemo, useState} from "react";
import {NamedColor, Palette} from "@/lib/color";

type Props = {
    color: string,
    onChange: (color: NamedColor) => any,
}

export default function Colorpicker({color, onChange}: Props) {
    const palette = useMemo(() => {
        return Palette();
    }, []);

    const [selectedColor, setSelectedColor] = useState<NamedColor>(
        palette.find((e) => e.color === color) || palette[0]
    );

    return (
        <View style={styles.container}>
            {palette.map(e => (
                <Pressable
                    key={e.color}
                    style={
                        [styles.circle, {
                            backgroundColor: e.color,
                            borderWidth: e.color === selectedColor.color ? 3 : 0,
                        }]}
                    onPress={() => {
                        setSelectedColor(e);
                        onChange(e);
                    }}
                />
            ))}
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        width: (72*4)+(16*3),
        marginHorizontal: "auto",
        flexDirection: "row",
        justifyContent: "space-around",
        alignItems: "flex-start",
        flexWrap: "wrap",
        gap: 16,
    },
    circle: {
        borderColor: Color.PrimaryText,
        borderRadius: 36,
        width: 72,
        height: 72,
    },
});